var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColumnGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4401 3.05957H5.56006C4.89759 3.06142 4.26277 3.3254 3.79433 3.79384C3.32589 4.26228 3.06191 4.8971 3.06006 5.55957V18.4396C3.06373 19.1015 3.32831 19.7352 3.79635 20.2033C4.2644 20.6713 4.89815 20.9359 5.56006 20.9396H18.4401C19.102 20.9359 19.7357 20.6713 20.2038 20.2033C20.6718 19.7352 20.9364 19.1015 20.9401 18.4396V5.55957C20.9382 4.8971 20.6742 4.26228 20.2058 3.79384C19.7373 3.3254 19.1025 3.06142 18.4401 3.05957ZM8.67006 19.9396H5.56006C5.16312 19.9367 4.78326 19.7777 4.50258 19.497C4.2219 19.2164 4.06294 18.8365 4.06006 18.4396V5.55957C4.06006 5.16175 4.21809 4.78021 4.4994 4.49891C4.7807 4.21761 5.16223 4.05957 5.56006 4.05957H8.67006V19.9396ZM9.67006 4.05957H14.3301V19.9396H9.67006V4.05957ZM19.9401 18.4396C19.9372 18.8365 19.7782 19.2164 19.4975 19.497C19.2169 19.7777 18.837 19.9367 18.4401 19.9396H15.3301V4.05957H18.4401C18.8379 4.05957 19.2194 4.21761 19.5007 4.49891C19.782 4.78021 19.9401 5.16175 19.9401 5.55957V18.4396Z",
    fill: "black",
    fillOpacity: 0.56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnGroup);
export default __webpack_public_path__ + "static/media/column-group.7ffe86056423722fb9401c6f25370134.svg";
export { ForwardRef as ReactComponent };